import styled from 'styled-components';

export const PasswordField = styled.div`
  position: relative;

  .form-control {
    padding-right: 44px;
  }

  .btn-link {
    position: absolute;
    top: 50%;
    right: 4px;
    display: inline-flex;
    padding: 4px;
    transform: translateY(-50%);
  }

  .material-icons {
    font-size: 20px;
  }
`;
